import shopifyGenericDefaults from '../shopify-generic/config.js';

const wheelsFields = shopifyGenericDefaults.Widgets.find((w) => w.name === 'FacetBarWheels').fields;

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => !['SearchBox', 'SearchBoxDialogButton', 'SearchHeader', 'HeaderVehicleWidget'].includes(w.name),
    ),
    {
      name: 'SearchBox',
      location: { replace: '.header-search-global-form' },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        firstChildOf: '.head-row-slot-items',
        class: 'head-slot-global-search-link',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'SearchHeader',
      sortEntries: {
        'relevance': 'Best Match',
        'title': 'Name, A-Z',
        'title:desc': 'Name, Z-A',
        'collection_sort': 'Featured',
        'price': 'Price, Low to High',
        'price:desc': 'Price, High to Low',
        'published_at': 'Date, Old to New',
        'published_at:desc': 'Date, New to Old',
      },
      facetToggleConfig: {
        toggledFacet: { field: 'Universal', term: 'True' },
      },
    },
    {
      name: 'UniversalFacet',
      type: 'FacetToggle',
      toggledFacet: { field: 'Universal', term: 'True' },
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: '.cm_tab-content.cm_vehicle-search',
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 690,
      initCollapsed: !!window.Convermax.config?.ymmInitCollapsed,
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters && shopifyGenericDefaults.fitmentSearch.baseFields,
    },
    {
      name: 'HomeWheelBar',
      type: 'RequestPanel',
      location: '.cm_tab-content.cm_wheel-search',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: wheelsFields,
    },
    {
      name: 'HomeSearchBox',
      type: 'SearchBox',
      location: '.cm_tab-content.cm_keyword-search',
      template: 'SearchBox',
    },
  ],
};
